import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/nextjs'

import Spinner from '../components/Spinner'
import { NondescriptError } from '../components/NondescriptError'
import { Coupon } from '../types/types'
import ListCouponsComponent from '../components/Coupons/ListCouponsComponent'
import { getCoupons } from '../services/SubscriptionApiClient'

function Coupons() {
  const [coupons, setCoupons] = useState<Coupon[]>([])
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  async function getData() {
    try {
      setCoupons(await getCoupons())
    } catch (e) {
      Sentry.captureException(e)
      console.log(e)
      setError(true)
    }
  }

  useEffect(() => {
    getData().then(() => setLoaded(true))
  }, [])

  if (!loaded) {
    return <Spinner />
  }

  if (loaded && error) {
    return <NondescriptError />
  }

  return (
    <>
      <ListCouponsComponent coupons={coupons} loaded={loaded} />
    </>
  )
}

export default Coupons
